import { render, staticRenderFns } from "./Relationshipauth.vue?vue&type=template&id=68061a3e&scoped=true"
import script from "./Relationshipauth.vue?vue&type=script&lang=js"
export * from "./Relationshipauth.vue?vue&type=script&lang=js"
import style0 from "./Relationshipauth.vue?vue&type=style&index=0&id=68061a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68061a3e",
  null
  
)

export default component.exports